import styled from "styled-components";

export const Content = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ecf1f8;
    width: 100%;

    .content_button {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .button {
            margin-top: 1px;
            margin-right: 2px;
            position: absolute;
            top:0;
            right:0;
            font-size: 16px;
            color: #fff;
            line-height: 1.2;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            min-width: 120px;
            height: 50px;
            border-radius: 8px;
            z-index: 1;
            background: #ffa6ac;
            transition: all .4s;
            opacity: 0.5;
        }

        .button:hover {
            opacity: 1;
        }
    }
`;

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;

    .seat-content {
        display: flex;
        justify-content: center;
        overflow-x: scroll;
    }

    .container {
        margin: 50px 0;
    }

    .seat-picker__row__number {
        visibility: hidden;
    }

    .confirmed {
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .text {
        margin-top: 10%;
        font-size: 3vw;
    }

    .buttons {
        position: absolute;
        bottom: 0%;
        right: 0%;
        min-width: 50%;
        max-width: 50%;
    }
`;
